/**
 * Where /signin and /signup go once you're in: `?next=` when it is a path on
 * this site, else home. Never another origin — `//evil.com` and `/\evil.com`
 * look like paths but browsers read them as hosts.
 */
export function signInReturnPath(search: string): string {
  const next = new URLSearchParams(search).get("next");
  if (!next || !next.startsWith("/") || next.startsWith("//") || next.startsWith("/\\")) return "/";
  return next;
}
